/**
 * Alumni Blog Filters
 * Handles client-side filtering of blog posts by category tags
 */

class AlumniFilters {
  constructor() {
    this.filterBtns = document.querySelectorAll(".alumni-filter-btn");
    this.blogItems = document.querySelectorAll(".blog-post-item");
    this.activeFilter = "all";

    this.init();
  }

  init() {
    if (!this.filterBtns.length || !this.blogItems.length) {
      return;
    }

    // Add click listeners to filter buttons
    this.filterBtns.forEach((btn) => {
      btn.addEventListener("click", (e) => this.handleFilterClick(e));
    });

    // Initial filter application (show all)
    this.applyFilter("all");
  }

  /**
   * @param {Event} e
   */
  handleFilterClick(e) {
    const btn = /** @type {HTMLButtonElement} */ (e.currentTarget);
    const filter = btn.dataset.filter || "all";

    // Update active button
    this.filterBtns.forEach((b) => b.classList.remove("active"));
    btn.classList.add("active");

    // Apply filter
    this.applyFilter(filter);
    this.activeFilter = filter;
  }

  /**
   * @param {string} filter
   */
  applyFilter(filter) {
    let visibleCount = 0;

    this.blogItems.forEach((item) => {
      const tags = /** @type {HTMLElement} */ (item).dataset.tags || "";

      if (filter === "all") {
        // Show all items
        item.classList.remove("hidden-by-filter");
        visibleCount++;
      } else {
        // Check if item has the filter tag
        // Handle both singular and plural forms (e.g., "Future Dentist" matches "Future Dentists")
        const normalizedTags = tags.toLowerCase();
        const normalizedFilter = filter.toLowerCase();

        if (normalizedTags.includes(normalizedFilter)) {
          item.classList.remove("hidden-by-filter");
          visibleCount++;
        } else {
          item.classList.add("hidden-by-filter");
        }
      }
    });

    // Log filter result for debugging
    console.log(`Alumni filter: ${filter} - ${visibleCount} items visible`);
  }

  // Method to re-apply current filter (useful after pagination/infinite scroll)
  reapplyCurrentFilter() {
    // Re-query items in case new ones were added via infinite scroll
    this.blogItems = document.querySelectorAll(".blog-post-item");
    this.applyFilter(this.activeFilter);
  }
}

// Initialize on DOM ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initAlumniFilters);
} else {
  initAlumniFilters();
}

function initAlumniFilters() {
  const alumniFiltersInstance = new AlumniFilters();

  // Make instance available globally for re-filtering after infinite scroll
  /** @type {any} */ (window).alumniFilters = alumniFiltersInstance;

  // Re-apply filter when new content is loaded via infinite scroll
  // Listen for content updates
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length > 0) {
        // Check if blog post items were added
        const hasNewBlogItems = Array.from(mutation.addedNodes).some((node) => {
          return (
            node instanceof HTMLElement &&
            node.classList &&
            node.classList.contains("blog-post-item")
          );
        });

        const globalWindow = /** @type {any} */ (window);
        if (hasNewBlogItems && globalWindow.alumniFilters) {
          // Small delay to ensure DOM is ready
          setTimeout(() => {
            globalWindow.alumniFilters.reapplyCurrentFilter();
          }, 100);
        }
      }
    });
  });

  // Observe the blog posts container
  const container = document.querySelector(".blog-posts-container");
  if (container) {
    observer.observe(container, {
      childList: true,
      subtree: false,
    });
  }
}
